export default {
  title: {
    singular: 'Offer',
    plural: 'Offers'
  },
  breadcrumbs: 'Offers',
  breadcrumbsSelect: 'Select an Offer type',
  breadcrumbsSelectMobile: 'Offer type',
  breadcrumbsCreate: {
    birthday: 'Create a Birthday Offer',
    'specific-product': 'Create a Specific Deal',
    'general-product': 'Create a Storewide Deal',
    desktop: {
      Birthday: 'Create a Birthday Offer',
      TwoForOne: 'Create a 2 for 1',
      ProductAndService: 'Create a Specific Discount',
      Storewide: 'Create a General Offer'
    },
    mobile: {
      Birthday: 'Birthday Offer',
      TwoForOne: '2 for 1',
      ProductAndService: 'Specific Discount',
      Storewide: 'General Offer'
    }
  },

  selectType: {
    breadcrumb: 'Select an Offer type',
    general: {
      title: 'Storewide Deals',
      description: 'E.g: Black friday 15% off storewide; <br/>Buy one get one.'
    },
    specific: {
      title: 'Specific Product / Service',
      description: 'E.g: Appetizer 10% off; <br/>T-shirt $5 dollars off.'
    },
    birthday: {
      title: 'Birthday Offer',
      description: 'E.g: Get a free drink on your <br/>birthday week.',
      tooltip:
        'You already have an active birthday offer. Go to your active birthday offer and archive it before creating a new one.'
    },
    tagInStore: 'In-Store businesses only',
    disclaimer: 'Note: You can archive an Offer at anytime.'
  },
  selectTypeV2: {
    breadcrumb: 'Select an Offer type',
    general: {
      title: 'General Offer',
      description:
        'Create your own promo. Perfect for storewide sales, spend-based rewards, or anything outside the other categories. <b>(E.g. Holiday Sale – 25% Off Storewide)</b>'
    },
    specific: {
      title: 'Specific Discount',
      description:
        'Apply a discount to a specific product or service. Set a % or $ off discount. <b>(E.g: $5 Off T-shirts)</b>'
    },
    birthday: {
      title: 'Birthday Offer',
      description:
        'Give your customers something special on their birthday! <b>(E.g. Free Dessert with Entrée Purchase)</b>',
      tooltip:
        'You already have an active birthday offer. Go to your active birthday offer and archive it before creating a new one.'
    },
    twoForOne: {
      title: '2 for 1',
      description:
        'Create a “Buy One, Get One Free” deal. Choose the product your customers purchase and what they get for free. <b>(E.g: Buy One Burger, Get One Free)</b>'
    },
    tagInStore: 'In-store businesses only',
    disclaimer: 'Note: You can archive an Offer at anytime.'
  },
  form: {
    details: 'OFFER DETAILS',
    titleLabel: 'What is your Offer?',
    titleHelpText: {
      prefix: 'E.g.',
      Storewide:
        'Spend $50, get a special reward; Earn a reward for spending $30; Black Friday 10% OFF storewide',
      ProductAndService: '10% off for cappuccino',
      Birthday: 'Free dessert on your birthday',
      TwoForOne: 'Buy One Sandwich, Get One Free',
      HappyHour: 'Buy a beer, get a free appetizer during happy hour'
    },
    titleOverviewPlaceholder: {
      Storewide: '10% off for cappuccino',
      ProductAndService: '10% off for cappuccino',
      Birthday: 'Free cappuccino',
      TwoForOne: 'Buy One Burger, Get One Free',
      HappyHour: 'Buy a beer, get a free appetizer during happy hour'
    },
    titlePlaceholder: {
      prefix: 'E.g:',
      'general-product': 'Black friday - 25% OFF storewide!',
      'specific-product': '25% off for all flannel shirts',
      birthday: '$10 OFF during your checkout',
      Storewide: 'Black friday - 25% OFF storewide!',
      ProductAndService: '25% off for all flannel shirts',
      Birthday: '$10 OFF during your checkout',
      TwoForOne: 'Buy One Sandwich, Get One Free'
    },
    imageLabel: 'Upload your Offer image',
    imageCrop: 'Offer Image',
    originalLabel: 'Original price',
    discountLabel: 'Discount amount: {businessCurrency} or %',
    customerSavingsLabel: 'How much does your customer save with this offer?',
    customerTwoForOneSavingsLabel:
      'Original price of this item or service on your menu',
    discountTag:
      'Offer tag <span>(This tag will appear under every offer)</span>',
    discountTagHelpText: 'E.g. ONE TIME, CONTINUAL, 25% OFF, FREE',
    finePrint: 'FINE PRINT',
    rulesLabel: 'Select the rules for this Offer',
    rulesLabelBirthday: 'Birthday Offer rules',
    savingsCannotBeDetermined: {
      title: 'Saving cannot be determined',
      description:
        'Estimated savings are too variable to calculate for this offer.'
    },
    redemptionRules: {
      selectRedemption: 'Can be redeemed:',
      specialCode: 'For your online Offer, enter a promo code:',
      locationsLabel: 'Select locations for in-store redemption:',
      locationsAllLabel: 'All locations',
      sectionTitle: 'Redemption rules',
      specialCodeTooltip:
        'Within your provider settings, create a discounted offer and add the generated code here.',
      title: 'Offer Availability',
      description: 'Choose the days and times when this offer can be redeemed',
      day: {
        title: 'Redeemable on any day',
        description: 'Choose as many days as needed',
        expandedTitle: 'Which days is this offer available?',
        error: 'Select your offer availability'
      },
      hour: {
        title: 'Redeemable all day long',
        expandedTitle: 'During which hours is this offer available?',
        expandedDescription: 'Select the available time range',
        error: 'Choose your offer time range'
      },
      coinRule: {
        sectionTitle: 'Redemption Limit per Member',
        title: 'Members can redeem this Offer once per period'
      }
    },
    coinRule: {
      overviewEmpty: 'No redemption limit per member',
      overview: 'There is a limit of {coinLimit} {coin} per person',
      overviewApp:
        'This Offer has a limit of {coinLimit} redemption per person',
      noRestrictions: 'No additional rules & restrictions'
    },
    customerRule: {
      title: 'Total member limit',
      description:
        'Set the total number of members that can redeem this Offer.',
      overviewEmpty: 'No member limit',
      overview: '{customerLimit} {customer} can redeem this Offer'
    },
    otherRules: {
      redeemableOnline: 'Redeemable online',
      redeemableOnlineApp: 'Can only be redeemed online',
      redeemableInStore: 'Redeemable in-store',
      redeemableInStoreApp: 'Can only be redeemed in-store',
      redeemableOnlineAndInStore: `Redeemable online on {online} and in-store at {inStore}`,
      redeemableOnlineAndInStoreApp: `Can be redeemed online or in-store`,
      noCashValue: 'No cash value',
      mayBeCanceled: 'May be canceled at any time',
      notTransferable: 'Not transferable',
      noCashTransferableCanceled:
        'No cash value. Not transferable. May be canceled at any time.'
    },
    expirationRule: {
      title: 'Set a deadline',
      description:
        'Your Offer will run until a deadline is met or your member limit is reached.',
      overviewEmpty: 'No expiration date',
      overview: 'This Offer expires on {date}',
      overviewBirthday:
        "Valid 3 days before and until 3 days after person's birthday",
      overviewBirthdayApp:
        'Valid 3 days before and until 3 days after your birthday'
    },
    renewedRule: {
      title: 'Renewal Frequency',
      description:
        'Allow your members to redeem your offer again after a set time period.',
      subText: 'Renews every',
      tooltip: 'The maximum recurrence period is one year',
      overview: 'Redeemable once every {time} {period}',
      overviewOne: 'Redeemable once per {period}'
    },
    combineRule: {
      title: 'Offer combination',
      description: 'This Offer cannot be combined with other Coins or Offers.',
      overview: 'Cannot be combined with other Coins or Offers',
      overviewApp: 'This Offer cannot be combined with other Coins or Offers',
      overviewEmpty: 'This Coin can be combined with other Coins or offers'
    },
    imageUpload: {
      textDrag: 'Drag and drop an offer image or',
      btn: 'Upload a file',
      cropTitleDefault: 'Crop your offer image',
      warnNotification:
        'Please select a photo in correct form. Just jpg, png and svg'
    },
    advancedOptionsLabel: 'Advanced Options',
    idCardOverview: 'ID card required to validate the redemption in-store',
    descriptionLabel: 'Share more details or add a personal note',
    descriptionPlaceholder:
      'E.g. Enjoy the best breakfast in town made with fresh, organic ingredients that are locally sourced.',
    restrictionsLabel: 'Additional rules & restrictions',
    restrictionsPlaceholder:
      'E.g. Excludes breakfast burritos; Valid Mon-Thurs; Not valid on holidays',
    tagBirthdayClub: 'Birthday Offer',
    finePrintOverview: 'Fine print overview',
    btn: 'Create Offer',
    btnPreview: 'Your members view',
    errors: {
      title: 'Please enter an Offer title',
      image: "Upload an image to proceed with the offer's creation.",
      original: 'Enter the original price',
      discount: 'Enter the discount amount',
      code: 'Please enter a redemption code',
      tag: 'Please enter an Offer tag',
      avgDiscount: 'Please enter how much the customer will save.'
    }
  },
  emptyState: {
    title: 'Create your first Offer',
    titleMobile: 'Create your first Offer',
    description:
      'Create unique Offers, deals and promotions to bring in new members and grow your business.',
    button: 'Create new Offer'
  },
  share: {
    title: 'Offer created!',
    message: 'Let people know about this Offer!',
    btn: 'Copy link to share',
    btnShare: 'Share',
    btnSee: 'See my Offers',
    btnFinish: 'Finish'
  },
  preview: {
    title: 'Offer preview',
    description:
      'This is how people will view your Offer through their devices.<br/>Scroll on the mockup for an overview.',
    tag: 'Offer Preview',
    app: {
      title: 'Offer',
      share: 'Share',
      saveLater: 'Save for later',
      useNow: 'Use now'
    }
  },
  detail: {
    breadcrumbs: 'Offer details',
    tooltip: {
      opened: 'Number of times Offers have been viewed by members.',
      saved: 'Number of Offers that have been saved but not yet redeemed.',
      redeemed: 'Number of Offers that have been redeemed by members.',
      getDirections:
        'Number of times members tapped "Get Directions" to find your physical location.',
      shared: 'Number of times Offers have been shared by members.',
      nonMemberReached:
        'Total number of Twism app users, who are not yet members of your program, exposed to your brand while navigating the ecosystem.',
      offerImpressions:
        'Total number of times your Offers have been displayed to members within Twism. <a target="_blank" style="text-decoration: underline;font-weight:600;" href="https://support.twism.com/hc/en-us/articles/29210709420429-What-are-Offer-Impressions">Learn more</a>'
    },
    combineRule: {
      empty: 'Cannot be combined',
      overview: 'Can be combined'
    },
    redeemable: {
      both: 'Redeemable online & in-store',
      online: 'Redeemable online',
      instore: 'Redeemable in-store'
    },
    statusDisclaimer: {
      expired_offline_delete_location:
        'This offer expired because the only location available for redemptions was deleted.',
      expired_offline_online_delete_location:
        'This offer expired because the only location available for in-store redemption was deleted.',
      active_online_delete_location:
        'The previous offer expired because the in-store location was deleted. This new offer replaces the expired offer and <strong>can only be redeemed online</strong>.'
    },
    share: 'Share',
    archive: 'Archive Offer'
  }
};
